<template>
  <div class="table-responsive">
    <table class="table table-sm table-hover align-items-center mb-0">
      <thead class="bg-light">
        <tr>
          <th v-for="col in columnas" :key="col.key"
            :class="['text-uppercase text-secondary text-xs font-weight-bolder', col.tipo === 'agregacion' ? 'text-end pe-3' : 'ps-3']">
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fila, idx) in filas" :key="'r-' + idx">
          <td v-for="col in columnas" :key="col.key"
            :class="['text-sm', col.tipo === 'agregacion' ? 'text-end pe-3' : 'ps-3']">
            {{ formatearValor(fila[col.key], col) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

const DECIMALES_NUMERICOS = 2;

function formatearFechaDDMMYYYY(valor) {
  if (valor == null || valor === '') return '';
  const d = new Date(valor);
  if (isNaN(d.getTime())) return valor;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return day + '/' + month + '/' + d.getFullYear();
}

export default {
  name: 'InformesTablaResultado',
  props: {
    filas: { type: Array, default: () => [] },
    columnas: { type: Array, default: () => [] }
  },
  setup() {
    const formatearValor = (valor, col) => {
      if (col.key === '_etiqueta_' && (valor == null || valor === '')) return 'Total';
      if (valor == null || valor === '') return '—';
      if (col.isDate) return formatearFechaDDMMYYYY(valor) || '—';
      if (col.tipo === 'agregacion' && col.agregacion) {
        const n = Number(valor);
        if (isNaN(n)) return valor;
        if (col.agregacion === 'count') {
          return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
        return n.toLocaleString('es-ES', { minimumFractionDigits: DECIMALES_NUMERICOS, maximumFractionDigits: DECIMALES_NUMERICOS });
      }
      return valor;
    };
    return { formatearValor };
  }
};
</script>
